module.exports = __webpack_public_path__ + "static/3-21340fc0fe53decdbdd61b418fc70067.jpg";